import _ from 'lodash';
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState, } from 'react';
import ReactDOM from 'react-dom';
import { Key } from 'w3c-keys';
import styles from './popover.module.scss';
import { PopoverFlipUtil } from './popover-flip-utils';
import { PopoverUtil } from './popover-utils';
const PopoverPositionableComponent = ({ position, content, align, isVisible, showAlignArrow = false, appendToBody = true, setToggle = _.noop, targetRef = null, flipTooltipTemplate = null, closeOnModifierKeyPress = false, }, ref) => {
    const [postionRef, setPositionRef] = useState(null);
    const popperRef = useRef(null);
    const { width = 10, height = 10, top, left, bottom, right } = position || {};
    useImperativeHandle(ref, () => ({
        resizePopover: () => {
            window.dispatchEvent(new Event('resize'));
        },
    }));
    /**
     * Hide popper if we click anywhere OUTSIDE
     * the popper or the target node
     */
    const handleDocumentClick = (event) => {
        const isInsidePopper = popperRef &&
            popperRef.current &&
            popperRef.current.contains(event.target);
        if (isInsidePopper) {
            // Prevent the context menu mouse down event from propagating.
            // Use case:
            // The answer selection state will be reset on mouse down anywhere in the liveboard.
            // But It should not reset the chart selection state when mouse down inside the context menu.
            event.stopImmediatePropagation();
            return;
        }
        setToggle(false);
        // Reset the tooltip template to null when the popover is closed.
        if (flipTooltipTemplate) {
            window.tooltipTemplate = null;
        }
    };
    /**
     * closeOnModifierKeyPress will be true for only chart's context menu.
     * to press the command key to close the context menu
     */
    const onEscapeHandler = (event) => {
        if (event.key === Key.Escape ||
            (closeOnModifierKeyPress && (event.ctrlKey || event.metaKey))) {
            setToggle(false);
        }
        // Reset the tooltip template to null when the popover is closed.
        if (flipTooltipTemplate) {
            window.tooltipTemplate = null;
        }
    };
    useEffect(() => {
        const virtualReference = {
            getBoundingClientRect() {
                return {
                    width,
                    height,
                    top,
                    left,
                    bottom,
                    right,
                };
            },
        };
        setPositionRef(virtualReference);
    }, [bottom, height, left, position, right, top, width]);
    useEffect(() => {
        // Enabled the capturing phase by setting it to true to listen for the event during the capture phase.
        // This is necessary because the mousedown event is used to reset the chart's selection state in the liveboard.
        // The popover's mousedown event must be stopped immediately to prevent it from triggering the chart selection reset.
        document.addEventListener('mousedown', handleDocumentClick, true);
        return () => {
            document.removeEventListener('mousedown', handleDocumentClick, true);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bottom, height, left, position, right, top, width, popperRef]);
    useEffect(() => {
        document.addEventListener('keydown', onEscapeHandler);
        return () => {
            document.removeEventListener('keydown', onEscapeHandler);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { renderPopoverContent } = flipTooltipTemplate
        ? PopoverFlipUtil(targetRef !== null && targetRef !== void 0 ? targetRef : postionRef, styles, {
            content,
            appendToBody,
            align,
            showAlignArrow,
            isVisible,
            popperRef,
        }, flipTooltipTemplate)
        : PopoverUtil(targetRef !== null && targetRef !== void 0 ? targetRef : postionRef, styles, {
            content,
            appendToBody,
            align,
            showAlignArrow,
            isVisible,
            popperRef,
        });
    return (React.createElement(React.Fragment, null, appendToBody
        ? ReactDOM.createPortal(renderPopoverContent(), document.body)
        : renderPopoverContent()));
};
export const PopoverPositionable = forwardRef(PopoverPositionableComponent);
//# sourceMappingURL=popover-positionable.js.map